module.exports = __webpack_public_path__ + "img/12.31c3f119.jpg";